import { render, staticRenderFns } from "./SubscriptionReasonDialog.vue?vue&type=template&id=db12f648&scoped=true"
import script from "./SubscriptionReasonDialog.vue?vue&type=script&lang=js"
export * from "./SubscriptionReasonDialog.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionReasonDialog.vue?vue&type=style&index=0&id=db12f648&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db12f648",
  null
  
)

export default component.exports